(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-sticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinical-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var compares = document.querySelectorAll('[data-compare]');
    if (!compares.length) return;

    compares.forEach(function (compare) {
      var handle = compare.querySelector('[data-compare-handle]');
      if (!handle) return;

      var dragging = false;

      function setPosition(pct) {
        pct = Math.max(0, Math.min(100, pct));
        compare.style.setProperty('--position', pct + '%');
        handle.setAttribute('aria-valuenow', Math.round(pct));
      }

      function pctFromEvent(e) {
        var rect = compare.getBoundingClientRect();
        var x = e.clientX - rect.left;
        return (x / rect.width) * 100;
      }

      compare.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { compare.setPointerCapture(e.pointerId); } catch (_) {}
        setPosition(pctFromEvent(e));
      });

      compare.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPosition(pctFromEvent(e));
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        try { compare.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      compare.addEventListener('pointerup', endDrag);
      compare.addEventListener('pointercancel', endDrag);
      compare.addEventListener('pointerleave', endDrag);

      handle.addEventListener('keydown', function (e) {
        var current = parseInt(handle.getAttribute('aria-valuenow'), 10);
        if (isNaN(current)) current = 50;
        var step = e.shiftKey ? 10 : 5;
        var next = current;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown': next = current - step; break;
          case 'ArrowRight':
          case 'ArrowUp':   next = current + step; break;
          case 'Home':      next = 0;   break;
          case 'End':       next = 100; break;
          default: return;
        }
        e.preventDefault();
        setPosition(next);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-ingredients]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var triggers = section.querySelectorAll('[data-ingredient-trigger]');
      var tabTriggers = section.querySelectorAll('[role="tab"][data-ingredient-trigger]');
      var panels = section.querySelectorAll('[role="tabpanel"]');
      if (!triggers.length) return;

      function activate(id, focusTab) {
        triggers.forEach(function (el) {
          var match = el.getAttribute('data-ingredient-id') === id;
          el.setAttribute('data-active', match ? 'true' : 'false');
          if (el.getAttribute('role') === 'tab') {
            el.setAttribute('aria-selected', match ? 'true' : 'false');
            el.setAttribute('tabindex', match ? '0' : '-1');
            if (match && focusTab) el.focus();
          }
        });
        panels.forEach(function (panel) {
          var match = panel.getAttribute('data-ingredient-id') === id;
          panel.setAttribute('data-active', match ? 'true' : 'false');
          if (match) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          activate(trigger.getAttribute('data-ingredient-id'));
        });
        // hover (desktop nicety; mobile fires click)
        trigger.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            activate(trigger.getAttribute('data-ingredient-id'));
          }
        });
      });

      // Arrow-key cycling within the tablist
      tabTriggers.forEach(function (tab, idx) {
        tab.addEventListener('keydown', function (e) {
          var next = idx;
          switch (e.key) {
            case 'ArrowDown':
            case 'ArrowRight': next = (idx + 1) % tabTriggers.length; break;
            case 'ArrowUp':
            case 'ArrowLeft':  next = (idx - 1 + tabTriggers.length) % tabTriggers.length; break;
            case 'Home':       next = 0; break;
            case 'End':        next = tabTriggers.length - 1; break;
            default: return;
          }
          e.preventDefault();
          activate(tabTriggers[next].getAttribute('data-ingredient-id'), true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
